import { MARKER_ANCHOR } from '../utils/markerConstants';
import { createMarkerPopup } from '../utils/markerPopupUtils';
import { createPlanPopup } from '../utils/popupBuilder';
import { setOrders, setSolutionJson } from '../../../../actions';

export function attachHoverEvents(marker, ui, translations, map, ordersRef) {
  createMarkerPopup(
    marker,
    map,
    (data) => (data?.isEditing ? MARKER_ANCHOR.EDITING.y : MARKER_ANCHOR.NORMAL.y),
    (data) => createPlanPopup(data, translations, ordersRef.current),
  );
}

export function attachInteractionEvents(
  marker,
  feature,
  dispatch,
  ordersRef,
  solution,
  onMarkerDragEnd,
  map,
) {
  marker.addEventListener('contextmenu', (evt) => {
    evt.stopPropagation();
    const featureId = feature.properties.id;
    const newOrders = ordersRef.current.filter((o) => o.InternalID !== featureId);
    dispatch(setOrders(newOrders, false, solution.show));
    dispatch(setSolutionJson({ jsonTriggerVRP: true }));
  });

  marker.draggable = true;

  marker.addEventListener('dragstart', (evt) => {
    if (marker._removePopup) {
      marker._removePopup();
    }

    if (map._behavior) {
      map._behavior.disable();
    }

    const markerScreenPos = map.geoToScreen(evt.target.getGeometry());
    evt.target.offset = {
      x: evt.currentPointer.viewportX - markerScreenPos.x,
      y: evt.currentPointer.viewportY - markerScreenPos.y,
    };
    evt.stopPropagation();
  });

  marker.addEventListener('dragend', (evt) => {
    if (map._behavior) {
      map._behavior.enable();
    }
    evt.stopPropagation();
    onMarkerDragEnd(marker, feature);
  });

  marker.addEventListener('tap', (evt) => {
    evt.stopPropagation();
  });
}
